<div class="vlm-list-container overflow-auto h-100 p-2">
  @if (entries.length === 0) {
    <div class="d-flex align-items-center justify-content-center h-100 text-body-secondary">
      No VLM results available.
    </div>
  }
  <mat-grid-list cols="3" rowHeight="1:1" gutterSize="8px">
    @for (entry of entries; track entry.feature.id ?? $index) {
      <mat-grid-tile>
        <div class="vlm-card w-100 h-100 d-flex flex-column">

          <!-- Preview image -->
          @if (previewUrl(entry.vlm); as url) {
            <div class="vlm-card__image-wrapper">
              <img [src]="url" alt="VLM preview" class="vlm-card__image" />
              @if (entry.vlm.vlm_score !== undefined && entry.vlm.vlm_score !== null) {
                <span class="vlm-card__score-badge {{ scoreClass(entry.vlm.vlm_score) }}">
                  {{ entry.vlm.vlm_score }}
                  @if (entry.vlm.vlm_label) {
                    · {{ entry.vlm.vlm_label }}
                  }
                </span>
              }
            </div>
          } @else {
            <div class="vlm-card__image-placeholder d-flex align-items-center justify-content-center">
              <mat-icon>image_not_supported</mat-icon>
            </div>
          }

          <div class="vlm-card__body d-flex flex-column flex-fill p-2 gap-1">

            <!-- Score row (when no image) -->
            @if (!previewUrl(entry.vlm) && entry.vlm.vlm_score !== undefined) {
              <div class="d-flex align-items-center gap-1">
                <span class="vlm-card__score-inline {{ scoreClass(entry.vlm.vlm_score) }}">
                  {{ entry.vlm.vlm_score }}
                  @if (entry.vlm.vlm_label) { · {{ entry.vlm.vlm_label }} }
                </span>
              </div>
            }

            <!-- Narrative -->
            @if (entry.vlm.vlm_narrative) {
              <p class="vlm-card__narrative mb-0">{{ entry.vlm.vlm_narrative }}</p>
            }

            <!-- Rationale -->
            @if (entry.vlm.vlm_rationale) {
              <p class="vlm-card__rationale mb-0">{{ entry.vlm.vlm_rationale }}</p>
            }

            <!-- Dynamic properties table -->
            @if (propertyEntries(entry.vlm).length > 0) {
              <table class="vlm-card__props-table w-100">
                @for (prop of propertyEntries(entry.vlm); track prop.key) {
                  <tr>
                    <td class="vlm-card__prop-key">{{ prop.key }}</td>
                    <td class="vlm-card__prop-value">{{ prop.value }}</td>
                  </tr>
                }
              </table>
            }

            <!-- Navigate button -->
            <div class="d-flex justify-content-end mt-auto pt-1">
              <button mat-icon-button
                      [attr.aria-label]="'Zoom to feature'"
                      (click)="onNavigate(entry.feature)">
                <mat-icon>zoom_in</mat-icon>
              </button>
            </div>

          </div>
        </div>
      </mat-grid-tile>
    }
  </mat-grid-list>
</div>
